export interface OfferItem {
  label: string
  title: string
  description: string
  value: number
}

export const offerItems: OfferItem[] = [
  {
    label: 'Material principal',
    title: '30 Clases de Trail Running Listas para Usar',
    description: 'Sesiones completas con objetivo, entrada en calor, bloque central y vuelta a la calma. Abrís, leés y das la clase.',
    value: 55000,
  },
  {
    label: 'Banco de recursos',
    title: 'Banco de Ejercicios de Técnica, Fuerza y Coordinación',
    description: 'Progresiones para subida, descenso, estabilidad de tobillo y fuerza excéntrica, con variantes según el nivel del grupo.',
    value: 35000,
  },
  {
    label: 'Planificación',
    title: 'Planificador Mensual de Entrenamientos Trail',
    description: 'Estructurá el mes completo: cargas, descargas y picos de intensidad para que tus alumnos progresen sin lesionarse.',
    value: 30000,
  },
  {
    label: 'Protocolos',
    title: 'Guía de Seguridad para Salidas Outdoor',
    description: 'Checklists, protocolos de clima, botiquín y manejo de imprevistos para llevar grupos al cerro con respaldo profesional.',
    value: 40000,
  },
  {
    label: 'Bonus',
    title: 'Kit de Captación de Alumnos para Profes de Trail Running',
    description: 'Plantillas de comunicación, clase de prueba y propuesta de precios para llenar tu grupo sin improvisar la venta.',
    value: 20000,
  },
]

export const deliverables: string[] = [
  '6 libros digitales en formato PDF',
  'Mega Pack Trail',
  'Todos sus bonos',
  'Pagás con Mercado Pago',
  'Acceso inmediato',
  'Único pago',
  'Acceso vía mail',
]

export const offer = {
  checkoutUrl: 'https://mega-pack-trail-running.impultienda.ar/checkout',
  totalValue: 180000,
  price: 25990,
  discountLabel: '85% OFF',
  spots: 50,
  guaranteeDays: 7,
}
